import React from 'react';
import { AlertTriangle } from 'lucide-react';
import VaultSheet from './VaultSheet';

interface ConfirmSheetProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  danger?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// Generic confirm sheet: "remove item", "delete folder", "delete account".
const ConfirmSheet: React.FC<ConfirmSheetProps> = ({
  open,
  title,
  description,
  confirmLabel,
  danger = true,
  loading = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <VaultSheet open={open} onClose={onCancel} maxWidth="sm:max-w-sm" zIndex={90} label={title}>
      <div className="flex items-start gap-3">
        <div
          className="grid h-11 w-11 shrink-0 place-items-center rounded-full"
          style={{
            background: danger ? 'var(--v-danger-wash)' : 'var(--v-glass-2)',
            color: danger ? 'var(--v-danger)' : 'var(--v-accent)',
          }}
        >
          <AlertTriangle size={20} />
        </div>
        <div className="min-w-0 pt-0.5">
          <h3 className="v-display text-[19px] font-semibold leading-tight">{title}</h3>
          {description && <p className="mt-1.5 text-[14.5px] leading-snug text-[var(--v-text-2)]">{description}</p>}
        </div>
      </div>

      <div className="mt-6 flex gap-3">
        <button type="button" onClick={onCancel} disabled={loading} className="v-btn v-btn-ghost flex-1">
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading}
          className={`v-btn flex-1 ${danger ? 'v-btn-danger' : 'v-btn-primary'}`}
        >
          {loading ? 'Please wait…' : confirmLabel}
        </button>
      </div>
    </VaultSheet>
  );
};

export default ConfirmSheet;
